.error-text {
  cursor: help;
}
